import { useConfigUserFeedback } from './config-user-feedback-state';

export const useSetEntityOperationLoadingMsg = () => {
  const { setEntityOperationLoadingMsg } = useConfigUserFeedback((state) => ({
    setEntityOperationLoadingMsg: state.setEntityOperationLoadingMsg,
  }));

  return setEntityOperationLoadingMsg;
};
